import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import TiposDeSocioConstant from 'constants/tiposDeSocio'

const TipoSocioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO DE SOCIO' htmlFor='select-tipoSocio' md={4} />
      <Col md={8}>
        <Field name='tipoSocio'>
          {({ field }) => (
            <Form.Select
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='select-tipoSocio'
            >
              <option value=''>Seleccionar</option>
              {TiposDeSocioConstant.__array.map(x => (
                <option key={x.id} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoSocioFormGroup)
